import type { AttributeReviewMappingRow } from "@/hooks/useAttributeReview.types";

export function rowRequiresManualDecisions(
  row: AttributeReviewMappingRow,
): boolean {
  return row.needsReview === true;
}
